import { useState } from "react";
import { Avatar, Box, Dialog } from "@mui/material";

type ImageDto = {
  id: number;
  image: string;
};

interface ImagePreviewProps {
  images?: ImageDto[];
}

const ImagePreview=({ images }: ImagePreviewProps)=> {
  const [open, setOpen] = useState(false);

  if (!images || images.length === 0) {
    return <Avatar sx={{ bgcolor: "grey.400" }}>N/A</Avatar>;
  }

  return (
    <>
      <Box sx={{ display: "flex", position: "relative" }}>
        {images.slice(0, 3).map((img, index) => (
          <Avatar
            key={img.id || index}
            src={img.image}
            onClick={() => setOpen(true)}
            sx={{
              width: 40,
              height: 40,
              border: "2px solid white",
              cursor: "pointer",
              marginLeft: index === 0 ? 0 : -1.5, // overlap effect
              zIndex: images.length - index,
            }}
          />
        ))}
        {images.length > 3 && (
          <Avatar
            sx={{
              width: 40,
              height: 40,
              marginLeft: -1.5,
              bgcolor: "grey.500",
              fontSize: 14,
              cursor: "pointer",
            }}
            onClick={() => setOpen(true)}
          >
            +{images.length - 3}
          </Avatar>
        )}
      </Box>

      {/* Full image dialog */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
        <Box sx={{ p: 2, display: "flex", flexWrap: "wrap", gap: 2 }}>
          {images.map((img) => (
            <img
              key={img.id}
              src={img.image}
              alt={`return-${img.id}`}
              style={{ maxWidth: "200px", borderRadius: 8 }}
            />
          ))}
        </Box>
      </Dialog>
    </>
  );
}


export default ImagePreview;